__turbopack_context__.v({
  "gallery_child": "Activitygallery-module-scss-module__hsVGfG__gallery_child",
  "gallery_main": "Activitygallery-module-scss-module__hsVGfG__gallery_main",
  "gallery_sec": "Activitygallery-module-scss-module__hsVGfG__gallery_sec",
});
